import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-smart-classrooms',
  templateUrl: './smart-classrooms.component.html',
  styleUrls: ['./smart-classrooms.component.scss']
})
export class SmartClassroomsComponent implements OnInit {
  activeTab = 'classrooms';
  activeLightboxImage: string | null = null;

  classroomsImages = [
    '/assets/img/facilities/imgi_170_class_room_img1-1200x800.jpg',
    '/assets/img/facilities/imgi_167_class_room_img2-1200x800.jpg'
  ];

  cdcImages = [
    '/assets/img/facilities/imgi_146_CDC_room_new_img1-1400x762.jpg',
    '/assets/img/facilities/imgi_149_CDC_room_new_img2-1067x800.jpg',
    '/assets/img/facilities/imgi_152_CDC_room_new_img3-1067x800.jpg',
    '/assets/img/facilities/imgi_155_cdc_room4-1200x800.jpg',
    '/assets/img/facilities/imgi_158_cdc_room3-1200x800.jpg',
    '/assets/img/facilities/imgi_161_cdc_room2-1200x800.jpg',
    '/assets/img/facilities/imgi_164_cdc_room1-1200x800.jpg'
  ];

  constructor() { }

  ngOnInit(): void { }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
  }

  openLightbox(src: string): void {
    this.activeLightboxImage = src;
  }

  closeLightbox(): void {
    this.activeLightboxImage = null;
  }
}

